import './RAGProgressBar.css';

interface Props {
  progress: {
    total_documents: number;
    processed_documents: number;
    percentage: number;
  };
  message?: string | null;
  vectorStatus?: string | null;
  bm25Status?: string | null;
}

export default function RAGProgressBar({ progress, message, vectorStatus, bm25Status }: Props) {
  const percentage = Math.max(0, Math.min(100, progress.percentage ?? 0));

  return (
    <div className="rag-progress" role="status">
      <div className="rag-progress-header">
        <div className="rag-progress-title">Preparing RAG</div>
        <div className="rag-progress-count">
          {progress.processed_documents.toLocaleString()} / {progress.total_documents.toLocaleString()} ({percentage.toFixed(2)}%)
        </div>
      </div>

      {(message || vectorStatus || bm25Status) && (
        <div className="rag-progress-subtitle">
          {message && <span>{message}</span>}
          {(vectorStatus || bm25Status) && (
            <span className="rag-index-substatus">
              {vectorStatus && <span>Vector: {vectorStatus}</span>}
              {bm25Status && <span>BM25: {bm25Status}</span>}
            </span>
          )}
        </div>
      )}

      <div className="rag-progress-bar" aria-label="RAG preparation progress">
        <div className="rag-progress-fill" style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
}
